import React, { Fragment, memo } from 'react'

import { Typo } from 'components/_old/Typo/Typo'

import { Paper } from 'components/atoms/Paper'
import { Typography } from 'components/atoms/Typography'

const Disclaimer = memo(
  (): React.ReactElement => (
    <Fragment>
      <Typography size={24} weight="semibold" lineHeight="small">
        <Typo>Disclaimer</Typo>
      </Typography>
      <Paper top={32}>
        <Typography size={18} weight="semibold" lineHeight="small">
          <Typo>To the transferring scheme</Typo>
        </Typography>
      </Paper>
      <Paper top={24}>
        <Typography size={14}>
          <Typo>
            <ul>
              <li>
                I authorise and instruct you to transfer funds from the transferring scheme as listed in the
                "Transferring Scheme Information" section of this form directly to my InvestEngine Personal Pension.
              </li>
              <li>
                I authorise you to release all necessary information to InvestEngine and Quai Investment Services
                Limited to enable the transfer of funds to my InvestEngine Personal Pension.
              </li>
              <li>
                I have read all the information provided or made available to me by the transferring scheme as listed in
                the "Transferring Scheme Details" section of this application.
              </li>
              <li>
                I accept that in order to comply with regulator obligations, Quai Investment Services Limited and the
                transferring scheme named in this application may need to verify my identity and residential address and
                may use credit reference agency services and ask for my documents to verify my identity and address.
              </li>
              <li>
                Until the application is accepted, and complete, Quai Investment Services Limited responsibility is
                limited to the return of the total payment(s) to the transferring scheme.
              </li>
              <li>
                I accept that I will be responsible for any losses and / or expenses which are the result, and which a
                reasonable person would consider to be the probable result, of any untrue, misleading, or inaccurate
                information deliberately or carelessly given by me, or on my behalf, either in this form or with respect
                to benefits from the transferring scheme(s).
              </li>
              <li>
                Where the payment(s) made to my InvestEngine Personal Pension represents all of the funds under the
                transferring scheme(s) listed in the "Transferring Scheme Information" section of this form, then
                payment made as instructed will mean that I shall no longer be entitled to receive pension or other
                benefits from the transferring scheme(s) listed.
              </li>
              <li>
                Where the payments made to my InvestEngine Personal Pension represent part of the fund under the plan
                (s) listed in the "Transferring Scheme Details" section of this application, then payment made as
                instructed will mean that I shall no longer be entitled to receive pension or other benefits from that
                part of the transferring scheme(s) represented by the payment.
              </li>
              <li>
                I promise to accept responsibility in respect of any claims, losses and expenses that my InvestEngine
                Personal Pension and the transferring scheme may incur as a result of any incorrect information provided
                by me in this application or any failure on my part to comply with any aspect of this application.
              </li>
              <li>
                I confirm that the value of any tax‑free cash I have already taken combined with the benefits I am
                taking now are below my personal Lump Sum Allowance and Lump Sum and Death Benefit Allowance.
              </li>
              <li>
                I will be solely responsible for any additional tax charges or any penalties which arise if the
                information provided in this application is incorrect or if I have failed to comply with any aspect of
                this application.
              </li>
              <li>
                In addition, I promise to accept responsibility in respect of any claims, losses and expenses that Quai
                Investment Services Limited and the transferring scheme may incur as a result of any incorrect
                information provided by me in this application or of any failure on my part to comply with my aspect of
                this application.
              </li>
            </ul>
          </Typo>
        </Typography>
      </Paper>
    </Fragment>
  ),
)
Disclaimer.displayName = 'Disclaimer'

export { Disclaimer }
